import { render, staticRenderFns } from "./MemberMove.vue?vue&type=template&id=09ce6634"
import script from "./MemberMove.vue?vue&type=script&lang=js"
export * from "./MemberMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports